// libraries.
import { useSelector } from 'react-redux';

// selectors.
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';
import {
  getSelectedCoordinates,
  getSelectedBusinessLine,
} from '../store/slices/georeferencing-slice';

// api.
import { useGetMedianZonesQuery } from '../store/api-slices';

export const useMedianZonesForMarketMaker = () => {
  const country = useSelector(getCountry);
  const coordinates = useSelector(getSelectedCoordinates);
  const selectedBusinessLine = useSelector(getSelectedBusinessLine);
  const MARKET_MAKER = 'Market-Maker';

  // Solo disponible para MX
  const shouldFetch =
    selectedBusinessLine === MARKET_MAKER && !!coordinates && country === 'MX';

  const {
    data: medianZones,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useGetMedianZonesQuery(
    {
      latitude: coordinates?.lat || 0,
      longitude: coordinates?.lng || 0,
      radius: 2000,
      country: country || '',
    },
    {
      skip: !shouldFetch,
    }
  );

  return {
    medianZones,
    isLoading: isLoading || isFetching,
    error,
    refetch,
    shouldFetch,
  };
};
